import { render, staticRenderFns } from "./packageCenterAdd.vue?vue&type=template&id=38d20080&scoped=true&"
import script from "./packageCenterAdd.vue?vue&type=script&lang=js&"
export * from "./packageCenterAdd.vue?vue&type=script&lang=js&"
import style0 from "./packageCenterAdd.vue?vue&type=style&index=0&id=38d20080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d20080",
  null
  
)

export default component.exports